import { connect } from 'react-redux'

import Connector from 'common/builder/components/chart/FlowChart/nodes/shared/Connector'
import { CHOOSE_FIRST_STEP_NODE } from 'common/builder/constants/NodeType'
import { withNodeContext } from 'common/builder/controllers/chart/FlowChart/nodes/shared/NodeContext'
import { isBuilderEmptyState } from 'common/builder/selectors/builder/commonSelectors'
import * as entitySelectors from 'common/builder/selectors/builder/entitySelectors'
import * as sourceSelectors from 'common/builder/selectors/builder/sourceSelectors'

const ConnectorController = connect((state, props) => {
  const { builderId, handlers, sourceId, disabled, tooltip } = props

  const res = {
    id: null,
    targetId: null,
    onChangeStart: handlers.onNewConnectorDragStart,
    onChangeEnd: handlers.onNewConnectorDragEnd,
    disabled,
    tooltip,
  }
  const source = entitySelectors.getById(state, builderId, sourceId)

  const isChooseFirstStepNodeVisible = isBuilderEmptyState(state, builderId)

  if (source) {
    let targetId = sourceSelectors.getTargetId(state, builderId, sourceId)
    if (source.isStartingStep && isChooseFirstStepNodeVisible && !targetId) {
      targetId = CHOOSE_FIRST_STEP_NODE
    }

    res.targetId = targetId
    res.isFromStartingStep = source.isStartingStep
    if (targetId) {
      res.id = `${sourceId}_${targetId}`
    }
  }

  return res
})(Connector)

export default withNodeContext(ConnectorController)
